var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-grid__promo",style:({
		gridArea: `${_vm.data.columnSpan} / ${_vm.data.columnSpan}`,
		backgroundColor: _vm.data.bgColor,
	})},[_c('div',{class:[
			'block-container',
			_vm.data.horizontal,
			_vm.data.vertical,
		]},[_c('a',{class:[
					'block-content',
					_vm.data.textAlign,
				],style:({ color: _vm.data.textColor }),attrs:{"href":_vm.data.linkUrl}},[(_vm.data.image)?_c('img',{staticClass:"collection__item-promo",style:({ objectFit: _vm.data.bgSize }),attrs:{"src":_vm.$screen.large_up ? _vm.data.imageDesktop || _vm.data.image : _vm.data.image}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.title)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}}),_vm._v(" "),(_vm.data.linkText && _vm.data.buttonType.includes('link'))?_c('span',{class:[_vm.data.buttonType, { 'link-bottom': _vm.data.isLinkBottom }],domProps:{"textContent":_vm._s(_vm.data.linkText)}}):_vm._e(),_vm._v(" "),(_vm.data.linkText && !_vm.data.buttonType.includes('link'))?_c('button',{class:[
						_vm.data.buttonType,
						{ 'btn-black': _vm.data.textColor === 'black' },
						{ 'btn-white': _vm.data.textColor === 'white' },
						{ 'with-arrow': _vm.data.isButtonArrow },
						{ 'link-bottom': _vm.data.isLinkBottom },
					],domProps:{"textContent":_vm._s(_vm.data.linkText)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }